import axios from "axios";
import config from "config";

export async function loadEvaluations() {
    return axios.get(config.get('api.url') + "/?type=7000&no_cache=1")
}

export async function loadAgeChartData(auswid) {
    let urlToLoad =  config.get('api.url') + "/?type=7002&no_cache=1&auswid="+auswid;
    return axios.get(urlToLoad)
}

export async function loadMapChartData(auswid) {
    let urlToLoad =  config.get('api.url') + "/?type=7003&no_cache=1&auswid="+auswid;
    return axios.get(urlToLoad)
}

export async function loadKvChartData(auswid) {
    let urlToLoad =  config.get('api.url') + "/?type=7003&no_cache=1&auswid="+auswid;
    return axios.get(urlToLoad)
}

export async function loadYearChartData(auswid) {
    let urlToLoad =  config.get('api.url') + "/?type=7001&no_cache=1&auswid="+auswid;
    return axios.get(urlToLoad)
}

export function fillDataArraysYear(data, ausprid) {
    let result = [];
    let latestYear = calculateLatestYear(data);
    result.push({['latestYear']:latestYear});

    let firstYear = calculateFirstYear(data);
    result.push({['firstYear']:firstYear});

    let maleValues = [];
    let femaleValues = [];
    let totalValues = [];

    for (const dataKey in data) {
        if (data[dataKey]['ausprid']== ausprid) {
            let tmp = data[dataKey]['zeitwert'];
            let unixTmp = tmp * 1000;
            let date = new Date(unixTmp);
            let tmpYear = date.getFullYear();
            let col1 = 'zeitwert';
            let value = parseFloat(data[dataKey]['wert']);
            let col2 = 'value';


            if (data[dataKey]['geschlecht'] == 'm') {
                maleValues.push({[col1]:tmpYear, [col2]:value });
            } else if (data[dataKey]['geschlecht'] == 'w') {
                femaleValues.push({[col1]:tmpYear, [col2]:value });
            } else if (data[dataKey]['geschlecht'] == 'g') {
                totalValues.push({[col1]:tmpYear, [col2]:value });
            }
        }
    }

    //sort Arrays
    const sort = function(a, b){
        let keyA = parseInt(a['zeitwert']),
            keyB = parseInt(b['zeitwert']);
        // Compare the 2 dates
        if(keyA < keyB) return -1;
        if(keyA > keyB) return 1;
        return 0;
    }
    maleValues.sort(sort);
    femaleValues.sort(sort);
    totalValues.sort(sort);

    //get absoluteValues for latestYear from male and female

    let absoluteLatest = 0;
    let absoluteFirst = 0;
    let auspridAbsolute = 13;

    let absoluteLatestMale = 0;
    let absoluteLatestFemale = 0;

    for (const dataKey in data) {
        if (data[dataKey]['ausprid']== auspridAbsolute) {
            let tmp = data[dataKey]['zeitwert'];
            let unixTmp = tmp * 1000;
            let date = new Date(unixTmp);
            let tmpYear = date.getFullYear();

            if (tmpYear == latestYear) {
                let tmpWert = parseInt(data[dataKey]['wert']);

                if (data[dataKey]['geschlecht'] == 'm'){
                    absoluteLatestMale = tmpWert;
                } else if (data[dataKey]['geschlecht'] == 'w') {
                    absoluteLatestFemale = tmpWert;
                }
                absoluteLatest = absoluteLatest + tmpWert;
            } else if (tmpYear == firstYear) {
                absoluteFirst = absoluteFirst + parseInt(data[dataKey]['wert']);
            }
        }
    }

    let absoluteDelta = absoluteLatest - absoluteFirst;
    let percentageDelta = ((absoluteDelta/absoluteFirst)*100).toFixed(1);

    let ratioMaleFemale = (absoluteLatestMale/absoluteLatestFemale).toFixed(2);

    result.push({['yearListLabels']:extractValues(maleValues, 'zeitwert')});
    result.push({['yearListValuesMale']:extractValues(maleValues, 'value')});
    result.push({['yearListValuesFemale']:extractValues(femaleValues, 'value')});
    result.push({['yearListValuesTotal']:extractValues(totalValues, 'value')});
    result.push({['absoluteLatestYear']:absoluteLatest});
    result.push({['absoluteDeltaYear']:absoluteDelta});
    result.push({['percentageDeltaYear']:percentageDelta});
    result.push({['ratioMaleFemaleYear']:ratioMaleFemale});
    return result;
}

export function fillDataArraysKv(data, ausprid) {
    let result = [];
    let latestYear = calculateLatestYear(data);

    let kvValues = []

    for (const dataKey in data) {
        let tmp = data[dataKey]['zeitwert'];
        let unixTmp = tmp * 1000;

        let date = new Date(unixTmp);
        let tmpYear = date.getFullYear();



        if (tmpYear == latestYear && data[dataKey]['ausprid']== ausprid) {
            let regionid = data[dataKey]['regionsid'];
            let col1 = 'kvId';
            let value = data[dataKey]['wert'];
            let col2 = 'value';

            let mappedKVValue = mapKVIdToLabel(parseInt(regionid));
            kvValues.push({[col1]:mappedKVValue, [col2]:value });
        }
    }

    kvValues.sort(function(a, b){
        let keyA = parseFloat(a['value']),
            keyB = parseFloat(b['value']);
        // Compare the 2 dates
        if(keyA < keyB) return -1;
        if(keyA > keyB) return 1;
        return 0;
    });

    result.push({['mapLabels']:extractValues(kvValues, 'kvId')});
    result.push({['kvValues']:extractValues(kvValues, 'value')});

    return result;
}

export function fillDataArraysMap(data) {
    let result = [];
    let latestYear = calculateLatestYear(data);
    result.push({['latestYear']:latestYear});

    return result;
}

function mapKVIdToLabel(id) {
    let label = '';
    switch (id) {
        case 1:
            label =  'Schleswig-Holstein';
            break;
        case 2:
            label = 'Hamburg';
            break;
        case 3:
            label = 'Bremen';
            break;
        case 17:
            label = 'Niedersachsen';
            break;
        case 20:
            label = 'Westfalen-Lippe';
            break;
        case 38:
            label = 'Nordrhein';
            break;
        case 46:
            label = 'Hessen';
            break;
        case 51:
            label = 'Rheinland-Pfalz';
            break;
        case 52:
            label = 'Baden-Württemberg';
            break;
        case 71:
            label = 'Bayern';
            break;
        case 72:
            label = 'Berlin';
            break;
        case 73:
            label = 'Saarland';
            break;
        case 78:
            label = 'Mecklenburg-Vorpommern';
            break;
        case 83:
            label = 'Brandenburg';
            break;
        case 88:
            label = 'Sachsen-Anhalt';
            break;
        case 93:
            label = 'Thüringen';
            break;
        case 98:
            label = 'Sachsen';
            break;
    }
    return label;
}

export function fillDataArraysAge(data) {
    let result = [];
    let latestYear = calculateLatestYear(data);
    result.push({['latestYear']:latestYear});


    let maleValues = [];
    let femaleValues = [];

    for (const dataKey in data) {
        let tmp = data[dataKey]['zeitwert'];
        let unixTmp = tmp * 1000;

        let date = new Date(unixTmp);
        let tmpYear = date.getFullYear();

        if (tmpYear == latestYear) {
            let ausprid = data[dataKey]['ausprid'];
            let col1 = 'ausprid';
            let value = data[dataKey]['wert'];
            let col2 = 'value';

            let tmpArray = [{[col1]:ausprid, [col2]:value }];

            if (data[dataKey]['geschlecht'] == 'm') {
                maleValues.push({[col1]:ausprid, [col2]:value });

            } else {
                femaleValues.push({[col1]:ausprid, [col2]:value });
            }
        }
    }

    //check if both arrays contain the same ausprids, otherwise do ?? male against female
    for (let i=0; i< maleValues.length; i++) {
        let auspridContained = false;
        for (let j=0; j< femaleValues.length; j++) {
            if (maleValues[i]['ausprid'] == femaleValues[j]['ausprid']) {
                auspridContained = true;
                break;
            }
        }

        if (auspridContained == false) {
            femaleValues.push({'ausprid':maleValues[i]['ausprid'], ['value']:-20 });
        }
    }

    //check if both arrays contain the same ausprids, otherwise do ?? female against male
    for (let i=0; i< femaleValues.length; i++) {
        let auspridContained = false;
        for (let j=0; j< maleValues.length; j++) {
            if (femaleValues[i]['ausprid'] == maleValues[j]['ausprid']) {
                auspridContained = true;
                break;
            }
        }

        if (auspridContained == false) {
            maleValues.push({'ausprid':femaleValues[i]['ausprid'], ['wert']:-40 });
        }
    }

    //sort both arrays according the age intervalls
    maleValues.sort(function(a, b){
        let keyA = parseInt(a['ausprid']),
            keyB = parseInt(b['ausprid']);
        // Compare the 2 dates
        if(keyA < keyB) return -1;
        if(keyA > keyB) return 1;
        return 0;
    });

    femaleValues.sort(function(a, b){
        let keyA = parseInt(a['ausprid']),
            keyB = parseInt(b['ausprid']);
        // Compare the 2 dates
        if(keyA < keyB) return -1;
        if(keyA > keyB) return 1;
        return 0;
    });

    //fill Labels and data for male btw. female
    result.push({['ageListLabels']:mapAuspridsToLabels(maleValues)});
    result.push({['ageListValuesMale']:extractValues(maleValues, 'value')});
    result.push({['ageListValuesFemale']:extractValues(femaleValues, 'value')});

    return result;
}

function extractValues(data, col) {
    let result = [];
    for (const dataKey in data) {
        result.push(data[dataKey][col]);
    }
    return result;
}

function mapAuspridsToLabels(data) {
    let result = []

    for (const dataKey in data) {
        result.push(mapNumberToLabel(parseInt(data[dataKey]['ausprid'])));
    }

    return result;
}

function mapNumberToLabel(number) {
    let label = '';
    switch (number) {
        case 1:
            label =  '0-14';
            break;
        case 2:
            label = '15-19';
            break;
        case 3:
            label = '20-29';
            break;
        case 4:
            label = '30-39';
            break;
        case 5:
            label = '40-49';
            break;
        case 6:
            label = '50-59';
            break;
        case 7:
            label = '60-69';
            break;
        case 8:
            label = '70-79';
            break;
        case 9:
            label = '80-89';
            break;
        case 10:
            label = '>=90';
            break;
    }
    return label;
}

function calculateLatestYear(data) {
    let resultYear = 0;

    for (const dataKey in data) {
        let tmp = data[dataKey]['zeitwert'];
        let unixTmp = tmp * 1000;

        let date = new Date(unixTmp);
        let tmpYear = date.getFullYear();

        if (tmpYear > resultYear) {
            resultYear = tmpYear;
        }
    }
    return resultYear;
}

function calculateFirstYear(data) {
    let resultYear = 4000;

    for (const dataKey in data) {
        let tmp = data[dataKey]['zeitwert'];
        let unixTmp = tmp * 1000;

        let date = new Date(unixTmp);
        let tmpYear = date.getFullYear();

        if (tmpYear < resultYear) {
            resultYear = tmpYear;
        }
    }
    return resultYear;
}

